import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandIamTeamAccountSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { teamId, accountIds } = action;

  const iamTeamPermissionRevoke = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_IAM_TEAM_PERMISSION_REVOKE,
    teamId,
    accountIds,
  });

  if (iamTeamPermissionRevoke.type === constants.RTM_IAM_TEAM_PERMISSION_REVOKE_OK) {
    yield put(commandIamTeamAccountSummary(teamId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: iamTeamPermissionRevoke.message || <FormattedMessage {...messages.permissionRevokeError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_REVOKE_PERMISSION_ON_TEAM, catchErrors, sendRequest, connection);
}
